// ProductList.js
import React from 'react';
import { List, ListItem, ListItemButton, ListItemText, ListSubheader, Card } from '@mui/material'; // Import Card
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

const StyledListItemButton = styled(ListItemButton)(({ theme, selected }) => ({
  borderRadius: theme.shape.borderRadius,
  margin: theme.spacing(0.5, 0),
  backgroundColor: selected ? theme.palette.action.selected : 'transparent',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest,
  }),
}));

function ProductList({ products, selectedProductId, onProductSelect }) {
  return (
    // Wrap the List in a Card
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <List
        sx={{ width: '100%', bgcolor: 'background.paper', flexGrow: 1, overflowY: 'auto' }} // Add flexGrow and overflowY
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader" sx={{ bgcolor: 'background.paper' }}>
            Products
          </ListSubheader>
        }
      >
        {products.map((product) => (
          <ListItem key={product.id} disablePadding>
            <StyledListItemButton
              selected={selectedProductId === product.id}
              onClick={() => onProductSelect(product.id)}
            >
              <ListItemText
                primary={product.name}
                primaryTypographyProps={{
                  variant: 'body2',
                  fontWeight: 'bold',
                  color: 'text.secondary',
                }}
              />
            </StyledListItemButton>
          </ListItem>
        ))}
      </List>
    </Card>
  );
}

ProductList.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedProductId: PropTypes.string,
  onProductSelect: PropTypes.func.isRequired,
};

export default ProductList;
